<button
  class="btn"
  type="button"
  [attr.data-id]="controlId + text"
  [class]="{
    'btn-primary': btnColor === 'orange',
    'btn-secondary': btnColor === 'white',
    'btn-gray': btnColor === 'gray',
    'btn-resolve': btnColor === 'red-orange',
    'btn-icon': iconClass && !text
  }"
  [disabled]="isDisabled"
  (click)="onClick()"
>
  @if (iconLast) {
    <div class="d-flex justify-content-center align-items-center">
      <span class="button-text hide-empty">{{ text }}</span>

      @if (loading) {
        <i class="fad fa-spinner-third fa-spin ml-2"></i>
      }

      <i [class]="(iconClass ? 'ml-2': '') + ' ' + (iconClass || 'hide-empty')"></i>
    </div>
  } @else {
    <div class="d-flex justify-content-center align-items-center">
      <i [class]="iconClass || 'hide-empty'"></i>

      <span
        class="button-text hide-empty"
        [class]="(iconClass && text ? 'ml-2': '') + ' ' + (iconClassLast && text ? 'mr-2' : '')"
      >{{ text }}</span>

      @if (loading) {
        <i class="ml-2 fad fa-spinner-third fa-spin"></i>
      } @else {
        <i [class]="iconClassLast || 'hide-empty'"></i>
      }
    </div>
  }
</button>
